import { render, staticRenderFns } from "./ManualLicitacaoLicitante.vue?vue&type=template&id=3ea47bea&scoped=true"
import script from "./ManualLicitacaoLicitante.vue?vue&type=script&lang=js"
export * from "./ManualLicitacaoLicitante.vue?vue&type=script&lang=js"
import style0 from "./ManualLicitacaoLicitante.vue?vue&type=style&index=0&id=3ea47bea&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea47bea",
  null
  
)

export default component.exports